import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      fontWeight: 500,
      textAlign: 'center',
      padding: '10px',
      borderRadius: palette.borderRadius.default,
      backgroundColor: palette.background.underBox,
      color: palette.text.primary
    },
    red: {
      backgroundColor: palette.common.red,
      color: palette.common.white
    },
    green: {
      backgroundColor: palette.common.green
    },
    orange: {
      color: palette.common.black,
      backgroundColor: palette.common.orange
    },
    orangeOutlined: {
      backgroundColor: palette.background.underBox,
      color: palette.text.primary,
      outline: `2px solid ${palette.common.orange}`
    },
    orangeOutlinedGrey: {
      backgroundColor: palette.text.primary,
      color: palette.common.white,
      outline: `2px solid ${palette.common.orange}`
    },
    blur: {
      color: 'transparent',
      textShadow: '0 0 5px rgba(0,0,0,0.5)'
    },
    transparent: {
      backgroundColor: 'transparent'
    },
    grey: {
      backgroundColor: palette.text.primary,
      color: palette.common.white
    },
    rank: {
      fontWeight: 600,
      fontSize: '24px',
      width: '44px',
      borderRadius: palette.borderRadius.large
    },
    note: {
      width: '90px',
      '@media (max-width: 425px)': {
        width: '30px'
      }
    },
    avatar: {
      padding: '0px',
      background: 'none',
      '@media (max-width: 374px)': {
        display: 'none'
      }
    },
    icon: {
      width: '40px'
    },
    text: {
      margin: 0
    },
    name: {
      wordBreak: 'break-all'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
